import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { flowRight } from 'lodash'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { withTranslationCustom } from 'lib/i18next'
import { withRouter } from 'react-router-dom'

import Link from 'components/Link'
import FileImage from 'components/UI/FileImage/FileImage'

import './event-form-attachment-preview.pcss'

const EventFormAttachmentPreview = ({ attachment }) => {
    return (
        <div className={classNames('event-form-attachment-preview')}>
            <Link
                key={attachment.id}
                to={attachment.attachmentUrl}
                trackName="attachmentPreview"
            >
                <FileImage
                    imageUrl={attachment.thumbUrl ? attachment.attachmentUrl : null}
                    fileName={attachment.filename}
                    mediaType={attachment.mediatype}
                    contain
                />
            </Link>
        </div>
    )
}

EventFormAttachmentPreview.propTypes = {
    attachment: PropTypes.object.isRequired,
}

export default flowRight(
    withErrorBoundaryNoRender,
    withRouter,
    withTranslationCustom(),
)(EventFormAttachmentPreview)
